import { List } from 'framework/list';
import HandbookPageLayout from '../../Show/HandbookPage/HandbookPageLayout';
import useHandbookService from '../../handbookService';

const HandbookPage = () => {
  const { search } = useHandbookService();

  return (
    <List getDataMethod={search}>
      <HandbookPageLayout />
    </List>
  );
};

export default HandbookPage;
